import { Loader2 } from "lucide-react"
import { cn } from "@/lib/utils"

interface LoadingScreenProps {
  message?: string
  imageSrc?: string // Logo o imagen central
  overlay?: boolean
}

export const LoadingScreen = ({
  message = "Cargando, por favor espera...",
  imageSrc,
  overlay = true,
}: LoadingScreenProps) => {
  return (
    <div
      className={cn(
        "flex items-center justify-center min-h-screen w-full transition-colors duration-300",
        overlay ? "fixed inset-0 z-50 bg-black/20 dark:bg-gray-900/60 backdrop-blur-sm" : "",
      )}
      style={{
        background: "var(--gradient-background)", // define tu gradiente en CSS para ambos modos
      }}
    >
      <div className="flex flex-col items-center justify-center space-y-6 relative z-10">
        {/* Contenedor del logo con spinner */}
        <div className="relative w-32 h-32 md:w-40 md:h-40">
          {/* Spinner circular */}
          <div className="absolute inset-0 rounded-full border border-primary dark:border-primary/80 animate-spin-slow"></div>

          {/* Imagen/logo central */}
          {imageSrc ? (
            <img
              src={imageSrc}
              alt="Logo"
              className="w-full h-full rounded-full object-cover shadow-lg"
            />
          ) : (
            <Loader2 className="w-full h-full text-primary dark:text-primary/80 animate-spin" />
          )}
        </div>

        {/* Texto animado */}
        <p className="text-lg md:text-xl font-semibold animate-pulse text-center max-w-xs text-gray-900 dark:text-gray-100">
          {message}
        </p>

        {/* Barra de progreso simulada */}
        <div className="w-64 h-2 rounded-full overflow-hidden bg-gray-200 dark:bg-gray-700">
          <div className="h-full bg-primary dark:bg-primary/80 animate-loading"></div>
        </div>
      </div>

      {/* Fondo animado con gradientes suaves */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-500 via-red-500 to-indigo-500 opacity-10 dark:opacity-20 animate-gradient-x pointer-events-none" />
    </div>
  )
}
